export type NameList = Record<string, Array<string>>;

export const ANIMAL_NAMES: NameList = {
  A: ["Alligator", "Alpaca", "Antelope", "Ape"],
  B: ["Bat", "Bear", "Beaver", "Bee", "Bird", "Butterfly"],
  C: ["Camel", "Cat", "Chicken", "Coyote", "Crow", "Crocodile"],
  D: ["Deer", "Dinosaur", "Dog", "Dolphin", "Donkey", "Duck"],
  E: ["Eagle", "Elephant", "Emu", "Eel"],
  F: ["Falcon", "Fish", "Flamingo", "Fly", "Frog"],
  G: ["Giraffe", "Goat", "Goose", "Gorilla", "Grasshopper"],
  H: ["Hamster", "Hedgehog", "Hornet", "Horse"],
  I: ["Impala"],
  J: ["Jaguar", "Jackal", "Jackrabbit", "Jellyfish"],
  K: ["Koala", "Kangaroo", "Kiwi"],
  L: ["Leopard", "Lion", "Llama", "Lemur", "Lizard", "Lobster", "Lemming", "Lynx"],
  M: ["Mole", "Monkey", "Moose", "Mouse", "Mule", "Mockingbird"],
  N: ["Nandu", "Nighthawk"],
  O: ["Opossum", "Owl", "Octopus", "Orca", "Ostrich", "Otter", "Orangutan", "Okapi", "Ocelot", "Oyster"],
  P: ["Panda", "Parrot", "Penguin", "Pig", "Pigeon"],
  R: ["Rabbit", "Raccoon", "Rat", "Raven", "Reindeer"],
  S: ["Seal", "Seastar", "Shark", "Sheep", "Skunk", "Snake", "Spider", "Squirrel", "Swan"],
  T: ["Termite", "Tiger", "Turkey", "Turtle"],
  U: ["Unicorn", "Urchin"],
  V: ["Vulture"],
  W: ["Walrus", "Wasp", "Weasel", "Whale", "Wolf", "Wombat"],
  Y: ["Yak"],
  Z: ["Zebra"],
};

export const MYTHICAL_CREATURES: NameList = {
  A: ["Alien", "Angel"],
  B: ["Bigfoot", "Bogeyman", "Bookworm"],
  C: ["Centaur", "Cerberus", "Chtulhu", "Cyclops"],
  D: ["Demon", "Devil", "Doppelganger", "Dragon", "Dwarf"],
  E: ["Elf", "Erlking"],
  F: ["Fairy"],
  G: ["Gargoyle", "Genie", "Ghost", "Ghoul", "Giant", "Gnome", "Goblin", "Golem", "Gorgon", "Gremlin", "Griffin"],
  H: ["Harpy", "Hellhound"],
  I: ["Imp", "Incubus"],
  J: ["Jackalope"],
  K: ["Kobold", "Kraken"],
  L: ["Leprechaun"],
  M: ["Magician", "Mandrake", "Manticore", "Medusa", "Merman", "Mermaid", "Minotaur", "Mummy"],
  N: ["Nessy", "Nymph"],
  O: ["Orc"],
  P: ["Pegasus", "Phoenix", "Pixie", "Poltergeist"],
  R: ["Redcap", "Revenant"],
  S: ["Santa", "Sasquatch", "Satan", "Satyr", "Siren", "Sorcerer", "Sorceress", "Sphinx", "Succubus", "Skywalker"],
  T: ["Thunderbird", "Troll"],
  U: ["Undead", "Unicorn"],
  V: ["Vampire"],
  W: ["Warlock", "Werewolf", "Witch", "Witcher", "Wizard", "Wraith"],
  Y: ["Yeti"],
  Z: ["Zombie"],
};

export const ADJECTIVES: NameList = {
  A: ["Adorable", "Adventurous", "Acrobatic", "Afraid", "Aggressive", "Agile", "Amazing", "Angry", "Anxious", "Ashamed", "Awesome", "Awful", "Awkward"],
  B: ["Bad", "Beautiful", "Beloved", "Best", "Black", "Bold", "Brave", "Brilliant", "Busy"],
  C: ["Calm", "Charming", "Cheap", "Cold", "Concerned", "Cool", "Crazy", "Creative", "Critical", "Curly", "Cute"],
  D: ["Dangerous", "Dark", "Deadly", "Delicious", "Difficult", "Direct", "Dirty", "Dizzy"],
  E: ["Eager", "Educated", "Elegant", "Excellent", "Excited"],
  F: ["Fabulous", "Fake", "Fast", "Fearless", "Focused", "Foolish", "Fresh", "Funky", "Funny", "Furious", "Fearsome"],
  G: ["Giant", "Gifted", "Good", "Grand", "Great", "Grown", "Grumpy"],
  H: ["Hairy", "Handsome", "Happy", "Heavy", "Hot", "Huge"],
  I: [
    "Icy",
    "Idealistic",
    "Illogical",
    "Immoral",
    "Immortal",
    "Imperial",
    "Indestructible",
    "Impeccable",
    "Improper",
    "Inconceivable",
    "Incredible",
    "Infernal",
    "Inspiring",
    "Intense",
    "Irate",
    "Interesting",
    "Intricate",
  ],
  J: ["Jealous", "Jazzy", "Jurassic", "Jumpy", "Jacobean", "Jowly", "Jarring", "Justified", "Joyful", "Juvenile", "Judgmental", "Jinxed", "Jeering", "Jovial", "Jesting"],
  K: ["Keen", "Kind", "Kissy", "Knowing", "Kinetic", "Knightly"],
  L: ["Lame", "Large", "Lazy", "Lean", "Little", "Lonely", "Lovely", "Loyal"],
  M: ["Mad", "Majestic", "Major", "Massive", "Mean", "Modern", "Mysterious"],
  N: ["Naive", "Naked", "Nameless", "Narcissistic", "Nerdy", "Noble", "Nutty", "Nosy"],
  O: ["Oily", "Odd", "Old", "Optimistic", "Ordinary", "Outstanding"],
  P: ["Pale", "Peaceful", "Perfect", "Phony", "Pink", "Polite", "Poor", "Positive", "Pretty", "Proud"],
  R: ["Rare", "Raw", "Reckless", "Remote", "Rich", "Rough", "Royal", "Rude"],
  S: ["Sad", "Sarcastic", "Scared", "Scary", "Secret", "Sexy", "Shiny", "Silly", "Sour", "Spicy", "Strong", "Stylish", "Super", "Suspicious"],
  T: ["Tasty", "Tempting", "Terrible", "Thin", "Tiny", "Tough", "Twin"],
  U: ["Unstoppable", "Unbearable", "Unmovable", "Unbreakable", "Uber", "Unique", "Upbeat", "Ultra", "Ultrasonic", "Underrated", "Understanding", "Urban"],
  V: ["Vagabond", "Valiant", "Vehement", "Velvety", "Verbose", "Versatile", "Vindictive", "Violent", "Vulnerable"],
  W: ["Wealthy", "Weak", "Weird", "Wet", "White", "Wicked", "Wild", "Wise", "Worst"],
  Y: ["Yappy", "Yodeling", "Youthful", "Yummy", "Yearling", "Yelping", "Young"],
  Z: ["Zany", "Zealous", "Zigzag", "Zazzy", "Zappy", "Zestful", "Zen", "Zingy", "Zippy"],
};
